<template>
    <div
        v-if="videoUrl"
        :class="classNames"
        ref="container"
    >
        <iframe
            v-if="resized"
            width="100%"
            height="100%"
            frameborder="0"
            allowfullscreen
            :src="videoUrl"
        />
    </div>
</template>

<script>
    /**
     * Position:
     * A - Above job description
     * B - Below job description
     */

    import {mapState} from 'vuex';

    export default {
        name: 'JobViewVideo',

        props: {
            position: {
                type: String,
                default: () => 'B',
            },
        },

        data() {
            return {
                resized: false,
                aspectRatio: 16 / 9,
                services: [
                    {
                        reg: /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/i,
                        url: 'https://www.youtube.com/embed/$5',
                    },
                    {
                        reg: /^.*vimeo.com\/(\d+)($|\/|\b)/i,
                        url: 'https://player.vimeo.com/video/$1',
                    },
                ],
            };
        },

        computed: {
            ...mapState({
                $_job: state => state.job.job,
            }),

            videoUrl() {
                if (!this.showVideo) {
                    return null;
                }

                const videoUrl = this.$_job.video_url;

                for (const service of this.services) {
                    if (service.reg.exec(videoUrl)) {
                        return videoUrl.replace(service.reg, service.url);
                    }
                }

                return videoUrl;
            },

            videoPosition() {
                const position = this.$_job.video_position || 'B';

                if (['A', 'B'].includes(position)) {
                    return position;
                }

                return 'B';
            },

            showVideo() {
                if (!this.$_job.video_url) {
                    return false;
                }

                return this.$_job.video_url && this.position === this.videoPosition;
            },

            classNames() {
                const classes = ['job-video'];

                if (this.videoPosition === 'A') {
                    classes.push('job-video-above');
                    classes.push('afu-mb-3');
                } else {
                    classes.push('job-video-below');
                    classes.push('afu-my-3');
                }

                return classes;
            },
        },

        methods: {
            resizeFrame() {
                if (!this.$refs.container) {
                    return;
                }

                const height = this.$refs.container.offsetWidth / this.aspectRatio;

                this.$refs.container.style.height = height + 'px';

                this.resized = true;
            },
        },

        mounted() {
            this.resizeFrame();

            if (this.showVideo) {
                window.addEventListener('resize', this.resizeFrame);
            }
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.resizeFrame);
        },
    };
</script>
